import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import fr from "./lang/fr.json";
import en from "./lang/en.json";
import de from "./lang/de.json";
import pt from "./lang/pt.json";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: {
        translation: fr,
      },
      en: {
        translation: en,
      },
      de: {
        translation: de,
      },
      pt: {
        translation: pt,
      },
    },
    fallbackLng: "fr",
    supportedLngs: ["fr", "en", "de", "pt"],
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // Ordre de détection : localStorage en premier pour persister la langue
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
  });

export default i18n;


